/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Bosnisch2Inputs */

const en__field__enum_nativelanguage_bosnisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Bosnisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosnisch`)
};

const de__field__enum_nativelanguage_bosnisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Bosnisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosnisch`)
};

/**
* | output |
* | --- |
* | "Bosnisch" |
*
* @param {_Field__Enum_Nativelanguage_Bosnisch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_bosnisch2 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Bosnisch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Bosnisch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_bosnisch2(inputs)
	return de__field__enum_nativelanguage_bosnisch2(inputs)
});
export { _field__enum_nativelanguage_bosnisch2 as "_field__enum_nativeLanguage_Bosnisch" }